export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/app/assets/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/app/assets/pages/[...path].vue'),
    /* no children */
  },
  {
    path: '/analytics',
    name: '/analytics',
    component: () => import('/app/assets/pages/analytics.vue'),
    children: [
      {
        path: ':id',
        name: '/analytics/[id]',
        component: () => import('/app/assets/pages/analytics/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/automations',
    name: '/automations',
    component: () => import('/app/assets/pages/automations.vue'),
    children: [
      {
        path: ':id',
        name: '/automations/[id]',
        component: () => import('/app/assets/pages/automations/[id].vue'),
        children: [
          {
            path: 'analytics/:page',
            name: '/automations/[id]/analytics.[page]',
            component: () => import('/app/assets/pages/automations/[id]/analytics.[page].vue'),
            /* no children */
          },
          {
            path: 'delete',
            name: '/automations/[id]/delete',
            component: () => import('/app/assets/pages/automations/[id]/delete.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'new',
        name: '/automations/new',
        component: () => import('/app/assets/pages/automations/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/automations/:id/body',
    name: '/automations.[id].body',
    component: () => import('/app/assets/pages/automations.[id].body.vue'),
    /* no children */
  },
  {
    path: '/comments',
    name: '/comments',
    component: () => import('/app/assets/pages/comments.vue'),
    children: [
      {
        path: 'settings',
        name: '/comments/settings',
        component: () => import('/app/assets/pages/comments/settings.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/emails',
    name: '/emails',
    component: () => import('/app/assets/pages/emails.vue'),
    children: [
      {
        path: 'analytics',
        /* internal name: '/emails/analytics' */
        /* no component */
        children: [
          {
            path: ':ids',
            name: '/emails/analytics/[ids]',
            component: () => import('/app/assets/pages/emails/analytics/[ids].vue'),
            children: [
              {
                path: ':page',
                name: '/emails/analytics/[ids]/[page]',
                component: () => import('/app/assets/pages/emails/analytics/[ids]/[page].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'imports',
        /* internal name: '/emails/imports' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/emails/imports/[id]',
            component: () => import('/app/assets/pages/emails/imports/[id].vue'),
            /* no children */
          },
          {
            path: 'new',
            name: '/emails/imports/new',
            component: () => import('/app/assets/pages/emails/imports/new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'latest',
        name: '/emails/latest',
        component: () => import('/app/assets/pages/emails/latest.vue'),
        /* no children */
      },
      {
        path: 'new',
        name: '/emails/new',
        component: () => import('/app/assets/pages/emails/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/emails/:id',
    name: '/emails.[id]',
    component: () => import('/app/assets/pages/emails.[id].vue'),
    children: [
      {
        path: 'completed',
        name: '/emails.[id]/completed',
        component: () => import('/app/assets/pages/emails.[id]/completed.vue'),
        /* no children */
      },
      {
        path: 'details',
        name: '/emails.[id]/details',
        component: () => import('/app/assets/pages/emails.[id]/details.vue'),
        children: [
          {
            path: 'analytics/:page',
            name: '/emails.[id]/details/analytics.[page]',
            component: () => import('/app/assets/pages/emails.[id]/details/analytics.[page].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'drafting',
        name: '/emails.[id]/drafting',
        component: () => import('/app/assets/pages/emails.[id]/drafting.vue'),
        /* no children */
      },
      {
        path: 'history/:historyId?',
        name: '/emails.[id]/history.[[historyId]]',
        component: () => import('/app/assets/pages/emails.[id]/history.[[historyId]].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/events',
    name: '/events',
    component: () => import('/app/assets/pages/events.vue'),
    children: [
      {
        path: ':id',
        name: '/events/[id]',
        component: () => import('/app/assets/pages/events/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/feeds',
    name: '/feeds',
    component: () => import('/app/assets/pages/feeds.vue'),
    children: [
      {
        path: ':id',
        name: '/feeds/[id]',
        component: () => import('/app/assets/pages/feeds/[id].vue'),
        children: [
          {
            path: 'delete',
            name: '/feeds/[id]/delete',
            component: () => import('/app/assets/pages/feeds/[id]/delete.vue'),
            /* no children */
          },
          {
            path: 'notes/new',
            name: '/feeds/[id]/notes.new',
            component: () => import('/app/assets/pages/feeds/[id]/notes.new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'new',
        name: '/feeds/new',
        component: () => import('/app/assets/pages/feeds/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/feeds/:id/body',
    name: '/feeds.[id].body',
    component: () => import('/app/assets/pages/feeds.[id].body.vue'),
    /* no children */
  },
  {
    path: '/forms',
    name: '/forms',
    component: () => import('/app/assets/pages/forms.vue'),
    /* no children */
  },
  {
    path: '/forms/:id',
    name: '/forms.[id]',
    component: () => import('/app/assets/pages/forms.[id].vue'),
    /* no children */
  },
  {
    path: '/forms/new',
    name: '/forms.new',
    component: () => import('/app/assets/pages/forms.new.vue'),
    /* no children */
  },
  {
    path: '/home',
    name: '/home',
    component: () => import('/app/assets/pages/home.vue'),
    /* no children */
  },
  {
    path: '/inbox',
    name: '/inbox',
    component: () => import('/app/assets/pages/inbox.vue'),
    children: [
      {
        path: ':id',
        name: '/inbox/[id]',
        component: () => import('/app/assets/pages/inbox/[id].vue'),
        children: [
          {
            path: 'notes/new',
            name: '/inbox/[id]/notes.new',
            component: () => import('/app/assets/pages/inbox/[id]/notes.new.vue'),
            /* no children */
          },
          {
            path: 'subscriber',
            name: '/inbox/[id]/subscriber',
            component: () => import('/app/assets/pages/inbox/[id]/subscriber.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/keys',
    name: '/keys',
    component: () => import('/app/assets/pages/keys.vue'),
    children: [
      {
        path: ':id',
        name: '/keys/[id]',
        component: () => import('/app/assets/pages/keys/[id].vue'),
        /* no children */
      },
      {
        path: 'new',
        name: '/keys/new',
        component: () => import('/app/assets/pages/keys/new.vue'),
        /* no children */
      },
      {
        path: 'regenerate',
        name: '/keys/regenerate',
        component: () => import('/app/assets/pages/keys/regenerate.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/mentions',
    name: '/mentions',
    component: () => import('/app/assets/pages/mentions.vue'),
    children: [
      {
        path: ':id',
        name: '/mentions/[id]',
        component: () => import('/app/assets/pages/mentions/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/oauth',
    /* internal name: '/oauth' */
    /* no component */
    children: [
      {
        path: 'authorize',
        name: '/oauth/authorize',
        component: () => import('/app/assets/pages/oauth/authorize.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/platform',
    name: '/platform',
    component: () => import('/app/assets/pages/platform.vue'),
    /* no children */
  },
  {
    path: '/requests',
    name: '/requests',
    component: () => import('/app/assets/pages/requests.vue'),
    children: [
      {
        path: ':id',
        name: '/requests/[id]',
        component: () => import('/app/assets/pages/requests/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/search',
    name: '/search',
    component: () => import('/app/assets/pages/search.vue'),
    children: [
      {
        path: 'automations/:id',
        name: '/search/automations.[id]',
        component: () => import('/app/assets/pages/search/automations.[id].vue'),
        /* no children */
      },
      {
        path: 'subscribers/:id',
        name: '/search/subscribers.[id]',
        component: () => import('/app/assets/pages/search/subscribers.[id].vue'),
        /* no children */
      },
      {
        path: 'tags/:id',
        name: '/search/tags.[id]',
        component: () => import('/app/assets/pages/search/tags.[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/settings',
    /* internal name: '/settings' */
    /* no component */
    children: [
      {
        path: '',
        name: '/settings/',
        component: () => import('/app/assets/pages/settings/index.vue'),
        /* no children */
      },
      {
        path: 'archives',
        name: '/settings/archives',
        component: () => import('/app/assets/pages/settings/archives.vue'),
        /* no children */
      },
      {
        path: 'archives/analytics',
        name: '/settings/archives.analytics',
        component: () => import('/app/assets/pages/settings/archives.analytics.vue'),
        /* no children */
      },
      {
        path: 'archives/announcement',
        name: '/settings/archives.announcement',
        component: () => import('/app/assets/pages/settings/archives.announcement.vue'),
        /* no children */
      },
      {
        path: 'archives/css',
        name: '/settings/archives.css',
        component: () => import('/app/assets/pages/settings/archives.css.vue'),
        /* no children */
      },
      {
        path: 'archives/footer',
        name: '/settings/archives.footer',
        component: () => import('/app/assets/pages/settings/archives.footer.vue'),
        /* no children */
      },
      {
        path: 'archives/header',
        name: '/settings/archives.header',
        component: () => import('/app/assets/pages/settings/archives.header.vue'),
        /* no children */
      },
      {
        path: 'billing',
        name: '/settings/billing',
        component: () => import('/app/assets/pages/settings/billing.vue'),
        children: [
          {
            path: 'cancel',
            name: '/settings/billing/cancel',
            component: () => import('/app/assets/pages/settings/billing/cancel.vue'),
            /* no children */
          },
          {
            path: 'pricing',
            name: '/settings/billing/pricing',
            component: () => import('/app/assets/pages/settings/billing/pricing.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'books',
        name: '/settings/books',
        component: () => import('/app/assets/pages/settings/books.vue'),
        /* no children */
      },
      {
        path: 'books/:id',
        name: '/settings/books.[id]',
        component: () => import('/app/assets/pages/settings/books.[id].vue'),
        /* no children */
      },
      {
        path: 'books/new',
        name: '/settings/books.new',
        component: () => import('/app/assets/pages/settings/books.new.vue'),
        /* no children */
      },
      {
        path: 'danger-zone',
        name: '/settings/danger-zone',
        component: () => import('/app/assets/pages/settings/danger-zone.vue'),
        children: [
          {
            path: 'add-newsletter',
            name: '/settings/danger-zone/add-newsletter',
            component: () => import('/app/assets/pages/settings/danger-zone/add-newsletter.vue'),
            /* no children */
          },
          {
            path: 'delete-account',
            name: '/settings/danger-zone/delete-account',
            component: () => import('/app/assets/pages/settings/danger-zone/delete-account.vue'),
            /* no children */
          },
          {
            path: 'delete-newsletter',
            name: '/settings/danger-zone/delete-newsletter',
            component: () => import('/app/assets/pages/settings/danger-zone/delete-newsletter.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'data',
        name: '/settings/data',
        component: () => import('/app/assets/pages/settings/data.vue'),
        children: [
          {
            path: 'attachments',
            /* internal name: '/settings/data/attachments' */
            /* no component */
            children: [
              {
                path: ':id',
                name: '/settings/data/attachments/[id]',
                component: () => import('/app/assets/pages/settings/data/attachments/[id].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'exports',
            /* internal name: '/settings/data/exports' */
            /* no component */
            children: [
              {
                path: ':id',
                name: '/settings/data/exports/[id]',
                component: () => import('/app/assets/pages/settings/data/exports/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'domains',
        name: '/settings/domains',
        component: () => import('/app/assets/pages/settings/domains.vue'),
        /* no children */
      },
      {
        path: 'domains/hosting',
        name: '/settings/domains.hosting',
        component: () => import('/app/assets/pages/settings/domains.hosting.vue'),
        /* no children */
      },
      {
        path: 'domains/sending',
        name: '/settings/domains.sending',
        component: () => import('/app/assets/pages/settings/domains.sending.vue'),
        /* no children */
      },
      {
        path: 'email',
        name: '/settings/email',
        component: () => import('/app/assets/pages/settings/email.vue'),
        /* no children */
      },
      {
        path: 'email/css',
        name: '/settings/email.css',
        component: () => import('/app/assets/pages/settings/email.css.vue'),
        children: [
          {
            path: 'history/:historyId?',
            name: '/settings/email.css/history.[[historyId]]',
            component: () => import('/app/assets/pages/settings/email.css/history.[[historyId]].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'email/footer',
        name: '/settings/email.footer',
        component: () => import('/app/assets/pages/settings/email.footer.vue'),
        children: [
          {
            path: 'history/:historyId?',
            name: '/settings/email.footer/history.[[historyId]]',
            component: () => import('/app/assets/pages/settings/email.footer/history.[[historyId]].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'email/header',
        name: '/settings/email.header',
        component: () => import('/app/assets/pages/settings/email.header.vue'),
        children: [
          {
            path: 'history/:historyId?',
            name: '/settings/email.header/history.[[historyId]]',
            component: () => import('/app/assets/pages/settings/email.header/history.[[historyId]].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'email/template',
        name: '/settings/email.template',
        component: () => import('/app/assets/pages/settings/email.template.vue'),
        children: [
          {
            path: 'history/:historyId?',
            name: '/settings/email.template/history.[[historyId]]',
            component: () => import('/app/assets/pages/settings/email.template/history.[[historyId]].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'embedding',
        name: '/settings/embedding',
        component: () => import('/app/assets/pages/settings/embedding.vue'),
        /* no children */
      },
      {
        path: 'firewall',
        name: '/settings/firewall',
        component: () => import('/app/assets/pages/settings/firewall.vue'),
        /* no children */
      },
      {
        path: 'general',
        name: '/settings/general',
        component: () => import('/app/assets/pages/settings/general.vue'),
        /* no children */
      },
      {
        path: 'general/description',
        name: '/settings/general.description',
        component: () => import('/app/assets/pages/settings/general.description.vue'),
        children: [
          {
            path: 'history/:historyId?',
            name: '/settings/general.description/history.[[historyId]]',
            component: () => import('/app/assets/pages/settings/general.description/history.[[historyId]].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'integrations',
        name: '/settings/integrations',
        component: () => import('/app/assets/pages/settings/integrations.vue'),
        children: [
          {
            path: 'arena',
            name: '/settings/integrations/arena',
            component: () => import('/app/assets/pages/settings/integrations/arena.vue'),
            children: [
              {
                path: 'disconnect',
                name: '/settings/integrations/arena/disconnect',
                component: () => import('/app/assets/pages/settings/integrations/arena/disconnect.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'bigcommerce',
            name: '/settings/integrations/bigcommerce',
            component: () => import('/app/assets/pages/settings/integrations/bigcommerce.vue'),
            /* no children */
          },
          {
            path: 'bluesky',
            name: '/settings/integrations/bluesky',
            component: () => import('/app/assets/pages/settings/integrations/bluesky.vue'),
            /* no children */
          },
          {
            path: 'buysellads',
            name: '/settings/integrations/buysellads',
            component: () => import('/app/assets/pages/settings/integrations/buysellads.vue'),
            /* no children */
          },
          {
            path: 'discord',
            name: '/settings/integrations/discord',
            component: () => import('/app/assets/pages/settings/integrations/discord.vue'),
            children: [
              {
                path: 'disconnect',
                name: '/settings/integrations/discord/disconnect',
                component: () => import('/app/assets/pages/settings/integrations/discord/disconnect.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'fathom',
            name: '/settings/integrations/fathom',
            component: () => import('/app/assets/pages/settings/integrations/fathom.vue'),
            /* no children */
          },
          {
            path: 'google',
            name: '/settings/integrations/google',
            component: () => import('/app/assets/pages/settings/integrations/google.vue'),
            /* no children */
          },
          {
            path: 'linkedin',
            name: '/settings/integrations/linkedin',
            component: () => import('/app/assets/pages/settings/integrations/linkedin.vue'),
            children: [
              {
                path: 'disconnect',
                name: '/settings/integrations/linkedin/disconnect',
                component: () => import('/app/assets/pages/settings/integrations/linkedin/disconnect.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'mastodon',
            name: '/settings/integrations/mastodon',
            component: () => import('/app/assets/pages/settings/integrations/mastodon.vue'),
            /* no children */
          },
          {
            path: 'memberful',
            name: '/settings/integrations/memberful',
            component: () => import('/app/assets/pages/settings/integrations/memberful.vue'),
            children: [
              {
                path: 'plans',
                /* internal name: '/settings/integrations/memberful/plans' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: '/settings/integrations/memberful/plans/[id]',
                    component: () => import('/app/assets/pages/settings/integrations/memberful/plans/[id].vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'meta',
            name: '/settings/integrations/meta',
            component: () => import('/app/assets/pages/settings/integrations/meta.vue'),
            /* no children */
          },
          {
            path: 'patreon',
            name: '/settings/integrations/patreon',
            component: () => import('/app/assets/pages/settings/integrations/patreon.vue'),
            children: [
              {
                path: 'disconnect',
                name: '/settings/integrations/patreon/disconnect',
                component: () => import('/app/assets/pages/settings/integrations/patreon/disconnect.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'plausible',
            name: '/settings/integrations/plausible',
            component: () => import('/app/assets/pages/settings/integrations/plausible.vue'),
            /* no children */
          },
          {
            path: 'reddit',
            name: '/settings/integrations/reddit',
            component: () => import('/app/assets/pages/settings/integrations/reddit.vue'),
            /* no children */
          },
          {
            path: 'seline',
            name: '/settings/integrations/seline',
            component: () => import('/app/assets/pages/settings/integrations/seline.vue'),
            /* no children */
          },
          {
            path: 'shopify',
            name: '/settings/integrations/shopify',
            component: () => import('/app/assets/pages/settings/integrations/shopify.vue'),
            /* no children */
          },
          {
            path: 'simple_analytics',
            name: '/settings/integrations/simple_analytics',
            component: () => import('/app/assets/pages/settings/integrations/simple_analytics.vue'),
            /* no children */
          },
          {
            path: 'stripe',
            name: '/settings/integrations/stripe',
            component: () => import('/app/assets/pages/settings/integrations/stripe.vue'),
            children: [
              {
                path: 'disconnect',
                name: '/settings/integrations/stripe/disconnect',
                component: () => import('/app/assets/pages/settings/integrations/stripe/disconnect.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'tinylytics',
            name: '/settings/integrations/tinylytics',
            component: () => import('/app/assets/pages/settings/integrations/tinylytics.vue'),
            /* no children */
          },
          {
            path: 'tumblr',
            name: '/settings/integrations/tumblr',
            component: () => import('/app/assets/pages/settings/integrations/tumblr.vue'),
            children: [
              {
                path: 'disconnect',
                name: '/settings/integrations/tumblr/disconnect',
                component: () => import('/app/assets/pages/settings/integrations/tumblr/disconnect.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'twitter',
            name: '/settings/integrations/twitter',
            component: () => import('/app/assets/pages/settings/integrations/twitter.vue'),
            children: [
              {
                path: 'disconnect',
                name: '/settings/integrations/twitter/disconnect',
                component: () => import('/app/assets/pages/settings/integrations/twitter/disconnect.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'umami',
            name: '/settings/integrations/umami',
            component: () => import('/app/assets/pages/settings/integrations/umami.vue'),
            /* no children */
          },
          {
            path: 'zapier',
            name: '/settings/integrations/zapier',
            component: () => import('/app/assets/pages/settings/integrations/zapier.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'notifications',
        name: '/settings/notifications',
        component: () => import('/app/assets/pages/settings/notifications.vue'),
        /* no children */
      },
      {
        path: 'paid-subscriptions',
        name: '/settings/paid-subscriptions',
        component: () => import('/app/assets/pages/settings/paid-subscriptions.vue'),
        /* no children */
      },
      {
        path: 'paid-subscriptions/thank-you',
        name: '/settings/paid-subscriptions.thank-you',
        component: () => import('/app/assets/pages/settings/paid-subscriptions.thank-you.vue'),
        /* no children */
      },
      {
        path: 'paid-subscriptions/upgrade',
        name: '/settings/paid-subscriptions.upgrade',
        component: () => import('/app/assets/pages/settings/paid-subscriptions.upgrade.vue'),
        /* no children */
      },
      {
        path: 'portal',
        name: '/settings/portal',
        component: () => import('/app/assets/pages/settings/portal.vue'),
        /* no children */
      },
      {
        path: 'referrals',
        name: '/settings/referrals',
        component: () => import('/app/assets/pages/settings/referrals.vue'),
        /* no children */
      },
      {
        path: 'security',
        name: '/settings/security',
        component: () => import('/app/assets/pages/settings/security.vue'),
        children: [
          {
            path: 'change-email-address',
            name: '/settings/security/change-email-address',
            component: () => import('/app/assets/pages/settings/security/change-email-address.vue'),
            /* no children */
          },
          {
            path: 'disconnect-apple',
            name: '/settings/security/disconnect-apple',
            component: () => import('/app/assets/pages/settings/security/disconnect-apple.vue'),
            /* no children */
          },
          {
            path: 'disconnect-google',
            name: '/settings/security/disconnect-google',
            component: () => import('/app/assets/pages/settings/security/disconnect-google.vue'),
            /* no children */
          },
          {
            path: 'mfa/new',
            name: '/settings/security/mfa.new',
            component: () => import('/app/assets/pages/settings/security/mfa.new.vue'),
            /* no children */
          },
          {
            path: 'passkey/:id/delete',
            name: '/settings/security/passkey.[id].delete',
            component: () => import('/app/assets/pages/settings/security/passkey.[id].delete.vue'),
            /* no children */
          },
          {
            path: 'passkey/:id/edit',
            name: '/settings/security/passkey.[id].edit',
            component: () => import('/app/assets/pages/settings/security/passkey.[id].edit.vue'),
            /* no children */
          },
          {
            path: 'passkey/register',
            name: '/settings/security/passkey.register',
            component: () => import('/app/assets/pages/settings/security/passkey.register.vue'),
            /* no children */
          },
          {
            path: 'recovery-codes/delete',
            name: '/settings/security/recovery-codes.delete',
            component: () => import('/app/assets/pages/settings/security/recovery-codes.delete.vue'),
            /* no children */
          },
          {
            path: 'recovery-codes/generate',
            name: '/settings/security/recovery-codes.generate',
            component: () => import('/app/assets/pages/settings/security/recovery-codes.generate.vue'),
            /* no children */
          },
          {
            path: 'remove-password',
            name: '/settings/security/remove-password',
            component: () => import('/app/assets/pages/settings/security/remove-password.vue'),
            /* no children */
          },
          {
            path: 'totp/:id/delete',
            name: '/settings/security/totp.[id].delete',
            component: () => import('/app/assets/pages/settings/security/totp.[id].delete.vue'),
            /* no children */
          },
          {
            path: 'totp/:id/edit',
            name: '/settings/security/totp.[id].edit',
            component: () => import('/app/assets/pages/settings/security/totp.[id].edit.vue'),
            /* no children */
          },
          {
            path: 'totp/connect',
            name: '/settings/security/totp.connect',
            component: () => import('/app/assets/pages/settings/security/totp.connect.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'snippets',
        name: '/settings/snippets',
        component: () => import('/app/assets/pages/settings/snippets.vue'),
        /* no children */
      },
      {
        path: 'snippets/:id',
        name: '/settings/snippets.[id]',
        component: () => import('/app/assets/pages/settings/snippets.[id].vue'),
        children: [
          {
            path: 'delete',
            name: '/settings/snippets.[id]/delete',
            component: () => import('/app/assets/pages/settings/snippets.[id]/delete.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'snippets/new',
        name: '/settings/snippets.new',
        component: () => import('/app/assets/pages/settings/snippets.new.vue'),
        /* no children */
      },
      {
        path: 'subscribing',
        name: '/settings/subscribing',
        component: () => import('/app/assets/pages/settings/subscribing.vue'),
        /* no children */
      },
      {
        path: 'subscribing/churn',
        name: '/settings/subscribing.churn',
        component: () => import('/app/assets/pages/settings/subscribing.churn.vue'),
        children: [
          {
            path: 'drafting',
            name: '/settings/subscribing.churn/drafting',
            component: () => import('/app/assets/pages/settings/subscribing.churn/drafting.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'subscribing/confirmation',
        name: '/settings/subscribing.confirmation',
        component: () => import('/app/assets/pages/settings/subscribing.confirmation.vue'),
        children: [
          {
            path: 'drafting',
            name: '/settings/subscribing.confirmation/drafting',
            component: () => import('/app/assets/pages/settings/subscribing.confirmation/drafting.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'subscribing/gift',
        name: '/settings/subscribing.gift',
        component: () => import('/app/assets/pages/settings/subscribing.gift.vue'),
        children: [
          {
            path: 'drafting',
            name: '/settings/subscribing.gift/drafting',
            component: () => import('/app/assets/pages/settings/subscribing.gift/drafting.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'subscribing/gift-unsubscription',
        name: '/settings/subscribing.gift-unsubscription',
        component: () => import('/app/assets/pages/settings/subscribing.gift-unsubscription.vue'),
        children: [
          {
            path: 'drafting',
            name: '/settings/subscribing.gift-unsubscription/drafting',
            component: () => import('/app/assets/pages/settings/subscribing.gift-unsubscription/drafting.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'subscribing/premium_welcome',
        name: '/settings/subscribing.premium_welcome',
        component: () => import('/app/assets/pages/settings/subscribing.premium_welcome.vue'),
        children: [
          {
            path: 'drafting',
            name: '/settings/subscribing.premium_welcome/drafting',
            component: () => import('/app/assets/pages/settings/subscribing.premium_welcome/drafting.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'subscribing/reminder',
        name: '/settings/subscribing.reminder',
        component: () => import('/app/assets/pages/settings/subscribing.reminder.vue'),
        children: [
          {
            path: 'drafting',
            name: '/settings/subscribing.reminder/drafting',
            component: () => import('/app/assets/pages/settings/subscribing.reminder/drafting.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'subscribing/welcome',
        name: '/settings/subscribing.welcome',
        component: () => import('/app/assets/pages/settings/subscribing.welcome.vue'),
        children: [
          {
            path: 'drafting',
            name: '/settings/subscribing.welcome/drafting',
            component: () => import('/app/assets/pages/settings/subscribing.welcome/drafting.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'team',
        name: '/settings/team',
        component: () => import('/app/assets/pages/settings/team.vue'),
        children: [
          {
            path: ':id',
            /* internal name: '/settings/team/[id]' */
            /* no component */
            children: [
              {
                path: '',
                name: '/settings/team/[id]/',
                component: () => import('/app/assets/pages/settings/team/[id]/index.vue'),
                /* no children */
              },
              {
                path: 'delete',
                /* internal name: '/settings/team/[id]/delete' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/settings/team/[id]/delete/',
                    component: () => import('/app/assets/pages/settings/team/[id]/delete/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'new',
            name: '/settings/team/new',
            component: () => import('/app/assets/pages/settings/team/new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'tracking',
        name: '/settings/tracking',
        component: () => import('/app/assets/pages/settings/tracking.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/sponsorships',
    name: '/sponsorships',
    component: () => import('/app/assets/pages/sponsorships.vue'),
    children: [
      {
        path: ':id',
        name: '/sponsorships/[id]',
        component: () => import('/app/assets/pages/sponsorships/[id].vue'),
        children: [
          {
            path: 'slots',
            /* internal name: '/sponsorships/[id]/slots' */
            /* no component */
            children: [
              {
                path: ':slotId',
                name: '/sponsorships/[id]/slots/[slotId]',
                component: () => import('/app/assets/pages/sponsorships/[id]/slots/[slotId].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'new',
        name: '/sponsorships/new',
        component: () => import('/app/assets/pages/sponsorships/new.vue'),
        /* no children */
      },
      {
        path: 'settings',
        name: '/sponsorships/settings',
        component: () => import('/app/assets/pages/sponsorships/settings.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/subscribers',
    name: '/subscribers',
    component: () => import('/app/assets/pages/subscribers.vue'),
    children: [
      {
        path: ':id',
        name: '/subscribers/[id]',
        component: () => import('/app/assets/pages/subscribers/[id].vue'),
        children: [
          {
            path: 'change-email-address',
            name: '/subscribers/[id]/change-email-address',
            component: () => import('/app/assets/pages/subscribers/[id]/change-email-address.vue'),
            /* no children */
          },
          {
            path: 'notes/new',
            name: '/subscribers/[id]/notes.new',
            component: () => import('/app/assets/pages/subscribers/[id]/notes.new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'bulk-actions',
        /* internal name: '/subscribers/bulk-actions' */
        /* no component */
        children: [
          {
            path: 'new',
            name: '/subscribers/bulk-actions/new',
            component: () => import('/app/assets/pages/subscribers/bulk-actions/new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'imports',
        /* internal name: '/subscribers/imports' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/subscribers/imports/[id]',
            component: () => import('/app/assets/pages/subscribers/imports/[id].vue'),
            /* no children */
          },
          {
            path: 'new',
            name: '/subscribers/imports/new',
            component: () => import('/app/assets/pages/subscribers/imports/new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'new',
        name: '/subscribers/new',
        component: () => import('/app/assets/pages/subscribers/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/surveys',
    name: '/surveys',
    component: () => import('/app/assets/pages/surveys.vue'),
    children: [
      {
        path: ':id',
        name: '/surveys/[id]',
        component: () => import('/app/assets/pages/surveys/[id].vue'),
        children: [
          {
            path: 'notes/new',
            name: '/surveys/[id]/notes.new',
            component: () => import('/app/assets/pages/surveys/[id]/notes.new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'new',
        name: '/surveys/new',
        component: () => import('/app/assets/pages/surveys/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/tags',
    name: '/tags',
    component: () => import('/app/assets/pages/tags.vue'),
    children: [
      {
        path: ':id',
        name: '/tags/[id]',
        component: () => import('/app/assets/pages/tags/[id].vue'),
        children: [
          {
            path: 'notes/new',
            name: '/tags/[id]/notes.new',
            component: () => import('/app/assets/pages/tags/[id]/notes.new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'new',
        name: '/tags/new',
        component: () => import('/app/assets/pages/tags/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/webhooks',
    name: '/webhooks',
    component: () => import('/app/assets/pages/webhooks.vue'),
    children: [
      {
        path: ':id',
        name: '/webhooks/[id]',
        component: () => import('/app/assets/pages/webhooks/[id].vue'),
        /* no children */
      },
      {
        path: 'new',
        name: '/webhooks/new',
        component: () => import('/app/assets/pages/webhooks/new.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

